








































































































import {Vue, Component, Provide} from 'vue-property-decorator';
import {Utils} from '@/utils/Utils';
import {API} from '@/services/api/api';
import {mapActions} from 'vuex';
import {redirectTime} from '@/constants/constants';

@Component({
  methods: {...mapActions(['showSuccessToast', 'showErrorToast'])},
})
export default class UploadBackgroundImage extends Vue {
  //Store Variables
  showSuccessToast: any;
  showErrorToast: any;

  //Form Variables
  imageStatus = false;
  imagebase64URL = '';
  imageName = '';

  //Other Varibales
  loadingBtnStatus = false;
  imageValidationMsg: any = null;

  //convert image into base 64 string and display on screen
  async onFileChange(event: any) {
    const imageData = event.target.files[0];
    this.imageName = imageData.name;

    try {
      let base64url = await Utils.ngxBase64(imageData);
      if (base64url === null) alert('Something went wrong with image');
      else {
        this.imagebase64URL = base64url;
        this.imageValidationMsg = null;
      }
    } catch (error) {
      alert('Something went wrong with image');
    }
  }

  validateImage() {
    if (this.imageName === '' || this.imagebase64URL === '') {
      this.imageValidationMsg = 'Please choose image first. ';
      return false;
    } else {
      this.imageValidationMsg = null;
      return true;
    }
  }

  //submit button handler
  async _uploadHandler() {
    if (!this.validateImage()) {
      return false;
    }
    try {
      this.loadingBtnStatus = true;
      let imageurl = this.imagebase64URL.split('base64,')[1];

      let response = await API.createBgImageDetails(this.imageName, imageurl, this.imageStatus);
      this.loadingBtnStatus = false;
      if (response.data) {
        let message: string = response.message;
        if (message.includes('created new background image')) {
          message = 'Record added successfully';
        }
        this.showSuccessToast({msg: message});
        setTimeout(() => this._clickHandler(), redirectTime);
      } else {
        this.showErrorToast({msg: response.error});
      }
    } catch (error) {
      this.loadingBtnStatus = false;
      this.showErrorToast({msg: 'Network error'});
    }
  }

  _clickHandler() {
    this.$router.go(-1);
  }
}
